<div class="available-benefits-container">
  <!-- <div class="available-benefits-title">
    <mwp-text-translate text="Welcome to the Benefits section of MyWorkplace." jsonKey="availableBenefitsTitle" />
  </div>
  <div class="info">
    <mwp-text-translate text="Below is a series of benefit categories for which you have one or more available benefits. To review your benefit options, click on the tile of any category to access information on the benefits and available resources." jsonKey="availableBenefitsNote" />
  </div> -->
  @if (isLoading) {
    <div>
      <mwp-placeholder-card />
    </div>
  }
  @if (!isLoading && benefitCategories && benefitCategories.length > 0) {
    <div>
      <mwp-card-content-header [url]="apiUrl" />
    </div>
    <div class="row">
      <div class="col-2 ">
        <div class="content-container">
          <div class="title pb-0 d-flex justify-content-center text-uppercase">
            <mwp-text-translate text="Categories" jsonKey="categories" />
          </div>
          <div class="content pb-3">
          @for (benefitCategory of benefitCategories; track benefitCategory; let i = $index) {
            <div class="menu-block" [ngClass]="{'selected-menu-block': benefitCategory.id == selectedCategoryId}">
              <button id="i" (click)="onMenuSelection(benefitCategory)" [class.active]="benefitCategory.id === selectedCategoryId">
                {{ benefitCategory.benefitCategoryName }}
              </button>
            </div>
          }
          </div>
        </div>
      </div>
      <div class="col-10">
        @if (displayAvailableBenefits) {
          <div class=" mb-3">
            <mwp-table [tableId]="selectedCategoryId" [tableColumns]="availableBenefitColumns" [dataSource]="availableBenefits" [isCustomColumnNameMatchValueName]="true" header="Available Benefits" />
          </div>
        }
        @if (displayResourceLinks) {
          <div class="mb-3">
            <mwp-card-resource header="Resource Links" [resources]="benefitCategoryDocuments" [displayCategroyColumn]="false" [displayCarrierColumn]="false" />
          </div>
        }
        @if (displayFauxCategory) {
          <div>
            @if (categoryHTML) {
              <div [innerHTML]="categoryHTML | pipeSafeHTML"></div>
            }
            @if (categoryOptionHTML) {
              <div [innerHTML]="categoryOptionHTML | pipeSafeHTML"></div>
            }
          </div>
        }
      </div>
    </div>
  }
  
  @if (!isLoading && (!benefitCategories || benefitCategories.length == 0)) {
    <div class="message-container blue-fill text-centered mb-3">
      <mwp-text-translate text="You do not have any available benefits at this time." jsonKey="finalizeNoAvailableBenefits" />
    </div>
  }
</div>